import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Layout from './components/layout/Layout';
import AuthenticatedLayout from './components/layout/AuthenticatedLayout';
import Home from './pages/Home';
import InterpreterProfile from './pages/InterpreterProfile';
import ApplicationStatus from './pages/ApplicationStatus';
import Login from './pages/Login';
import SetupPassword from './pages/SetupPassword';
import ChangePassword from './pages/ChangePassword';
import JobDashboard from './pages/JobDashboard';
import JobSearch from './pages/JobSearch';
import JobDetails from './pages/JobDetails';
import JobTimer from './pages/JobTimer';
import JobAction from './pages/JobAction';
import ProfileEdit from './pages/ProfileEdit';
import PayoutSettings from './pages/PayoutSettings';
import ReferInterpreter from './pages/ReferInterpreter';
import MySchedule from './pages/MySchedule';
import PendingActions from './pages/PendingActions';
import ConfirmJob from './pages/ConfirmJob';
import CompletionReportPublic from './pages/CompletionReportPublic';
import TransportationCompletionReportPublic from './pages/TransportationCompletionReportPublic';
import TransportationProviderProfile from './pages/TransportationProviderProfile';
import ProviderDocumentUpload from './pages/ProviderDocumentUpload';
import TransportationTerms from './pages/TransportationTerms';
import TransportationTripDetails from './pages/TransportationTripDetails';
import TransportationCompletionReport from './pages/TransportationCompletionReport';
import TransportationFindTrips from './pages/TransportationFindTrips';
import TransportationTripOpportunity from './pages/TransportationTripOpportunity';
import ProviderHome from './pages/ProviderHome';
import ProviderProfilePage from './pages/ProviderProfilePage';
import AgencyMembers from './pages/AgencyMembers';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import { AuthProvider } from './contexts/AuthContext';
import { JobRestrictionProvider } from './contexts/JobRestrictionContext';
import ProtectedRoute from './components/common/ProtectedRoute';
import RoutePersistence from './components/RoutePersistence';
import SandboxBanner from './components/SandboxBanner';
import './styles/globals.css';
import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <SandboxBanner />
          <Toaster position="top-right" />
          <RoutePersistence />
          <Routes>
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/apply" element={<Layout><InterpreterProfile /></Layout>} />
            <Route path="/apply-transportation" element={<Layout><TransportationProviderProfile /></Layout>} />
            <Route path="/status" element={<Layout><ApplicationStatus /></Layout>} />
            <Route path="/terms" element={<Layout><Terms /></Layout>} />
            <Route path="/transportation-terms" element={<Layout><TransportationTerms /></Layout>} />
            <Route path="/privacy" element={<Layout><Privacy /></Layout>} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/signup" element={<SetupPassword />} />
            <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
            <Route path="/upload-documents/:token" element={<Layout><ProviderDocumentUpload /></Layout>} />
            <Route path="/job-timer/:token" element={<JobTimer />} />
            <Route path="/jobs/:jobId/confirm/:token" element={<ConfirmJob />} />
            <Route path="/jobs/:jobId/report/:token" element={<CompletionReportPublic />} />
            <Route path="/transportation-jobs/:jobId/report/:token" element={<TransportationCompletionReportPublic />} />
            <Route path="/transportation/trips/:tripId" element={<ProtectedRoute><AuthenticatedLayout><TransportationTripDetails /></AuthenticatedLayout></ProtectedRoute>} />
            <Route path="/transportation/trips/:tripId/completion-report" element={<ProtectedRoute><AuthenticatedLayout><TransportationCompletionReport /></AuthenticatedLayout></ProtectedRoute>} />
            <Route path="/trips/find" element={<ProtectedRoute><AuthenticatedLayout><TransportationFindTrips /></AuthenticatedLayout></ProtectedRoute>} />
            <Route path="/trips/find/:jobId" element={<ProtectedRoute><AuthenticatedLayout><TransportationTripOpportunity /></AuthenticatedLayout></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><JobRestrictionProvider><AuthenticatedLayout><ProviderHome /></AuthenticatedLayout></JobRestrictionProvider></ProtectedRoute>} />
            <Route path="/schedule" element={<ProtectedRoute><JobRestrictionProvider><AuthenticatedLayout><MySchedule /></AuthenticatedLayout></JobRestrictionProvider></ProtectedRoute>} />
            <Route path="/pending" element={<ProtectedRoute><JobRestrictionProvider><AuthenticatedLayout><PendingActions /></AuthenticatedLayout></JobRestrictionProvider></ProtectedRoute>} />
            <Route path="/jobs" element={<ProtectedRoute><JobRestrictionProvider><AuthenticatedLayout><JobDashboard /></AuthenticatedLayout></JobRestrictionProvider></ProtectedRoute>} />
            <Route path="/jobs/search" element={<ProtectedRoute><JobRestrictionProvider><AuthenticatedLayout><JobSearch /></AuthenticatedLayout></JobRestrictionProvider></ProtectedRoute>} />
            <Route path="/job/:jobId" element={<ProtectedRoute><JobRestrictionProvider><AuthenticatedLayout><JobDetails /></AuthenticatedLayout></JobRestrictionProvider></ProtectedRoute>} />
            <Route path="/jobs/:jobId/:action/:interpreterId" element={<ProtectedRoute><JobAction /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><JobRestrictionProvider><AuthenticatedLayout><ProviderProfilePage /></AuthenticatedLayout></JobRestrictionProvider></ProtectedRoute>} />
            <Route path="/agency-members" element={<ProtectedRoute><JobRestrictionProvider><AuthenticatedLayout><AgencyMembers /></AuthenticatedLayout></JobRestrictionProvider></ProtectedRoute>} />
            <Route path="/profile/edit" element={<ProtectedRoute><JobRestrictionProvider><AuthenticatedLayout><ProfileEdit /></AuthenticatedLayout></JobRestrictionProvider></ProtectedRoute>} />
            <Route path="/payout-settings" element={<ProtectedRoute><JobRestrictionProvider><AuthenticatedLayout><PayoutSettings /></AuthenticatedLayout></JobRestrictionProvider></ProtectedRoute>} />
            <Route path="/refer" element={<ProtectedRoute><JobRestrictionProvider><AuthenticatedLayout><ReferInterpreter /></AuthenticatedLayout></JobRestrictionProvider></ProtectedRoute>} />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
